module.exports = __webpack_public_path__ + "img/smok.a3febb36.png";